import React from 'react';
import {Avatar, Paper, Typography, Tooltip, Chip, Grid} from 'material-ui';
import classNames from 'classnames';
import {Link} from 'react-router-dom';
import EditIcon from 'material-ui-icons/Edit';
import {PAGE_TYPE_REVIEW} from '../../constants';
import {
    showEditGlobalButton,
    showEditTranslationButton,
} from '../../../../components/permissions/permissions';

const PageBuilderMeta = ({
    classes,
    title,
    subheading,
    handleRequestOpenDialog,
    page,
    hideActions,
    metaSectionData,
}) => {
    if (!page || !page.review || !metaSectionData) return null;

    const editMetaButton = (
        <Link to={'#'} className="floatRight">
            <Tooltip title="Edit Page Meta">
                <EditIcon
                    className="smallIconButtonPages editColor"
                    onClick={handleRequestOpenDialog}
                />
            </Tooltip>
        </Link>
    );

    const ShowEditMetaButton =
        page.site_id === 0
            ? showEditGlobalButton(() => editMetaButton)
            : showEditTranslationButton(() => editMetaButton);

    let sectionPaperClassNames = classNames(
        hideActions ? classes.pbMetaSectionComparePopup : classes.root,
        classes.marginTop0
    );

    let hasReviews =
        page.type !== undefined && page.type === PAGE_TYPE_REVIEW
            ? ' Review, '
            : ' ';

    return (
        <Paper elevation={2} className={sectionPaperClassNames}>
            <Grid container>
                <Grid item xs={12} md={6}>
                    <Grid
                        container
                        direction="row"
                        justify="flex-start"
                        spacing={0}
                    >
                        <Typography variant="title" gutterBottom>
                            {title ? title : ''}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid container direction="row" justify="flex-end">
                        <Chip
                            label={
                                'Headings *,' +
                                hasReviews +
                                'Hero image, Snippet * and Meta info *'
                            }
                            className={classes.sectionTitleChip}
                        />
                    </Grid>
                </Grid>
            </Grid>
            {subheading && (
                <Typography
                    variant="subheading"
                    gutterBottom
                    dangerouslySetInnerHTML={{__html: subheading}}
                />
            )}
            {page.breadcrumb_title && (
                <Typography variant="subheading" gutterBottom>
                    <strong>Breadcrumbs Title: </strong>
                    {page.breadcrumb_title}
                </Typography>
            )}
            {page.review.author_full_name && (
                <Typography gutterBottom>
                    <strong>Author Full Name: </strong>
                    {page.review.author_full_name}
                </Typography>
            )}
            {page.review.author_abbreviated_name && (
                <Typography gutterBottom>
                    <strong>Author Abbreviated Name: </strong>
                    {page.review.author_abbreviated_name}
                </Typography>
            )}
            {page.review.quote && (
                <Typography gutterBottom>
                    <strong>Quote:</strong> {page.review.quote}
                </Typography>
            )}
            {page.review.products &&
                page.review.products.map((product, index) => (
                    <Typography key={index} gutterBottom>
                        <strong>Product: </strong>
                        {product.display_name}
                    </Typography>
                ))}
            {page.heroImage &&
                page.heroImage.preview &&
                !page.heroImage.deleted && (
                    <Tooltip title="Hero Image">
                        <Avatar
                            src={page.heroImage.preview}
                            className={classNames(
                                classes.avatar,
                                classes.bigAvatar
                            )}
                        />
                    </Tooltip>
                )}
            {metaSectionData.review.image &&
                metaSectionData.review.image.preview &&
                !metaSectionData.review.image.deleted && (
                    <Tooltip title="Review Image">
                        <Avatar
                            src={metaSectionData.review.image.preview}
                            className={classNames(
                                classes.avatar,
                                classes.bigAvatar
                            )}
                        />
                    </Tooltip>
                )}
            {!hideActions && (
                <div className={classes.pbSectionActions}>
                    <ShowEditMetaButton />
                </div>
            )}
        </Paper>
    );
};

export default PageBuilderMeta;



// WEBPACK FOOTER //
// ./src/containers/builder/sections/tab_edit/builder_meta.js